export const TaskDateFormatter = Symbol('TaskDateFormatter');

/**
 * @description
 * 任务日期格式化器
 */
export interface TaskDateFormatter {
    /**
     * @description
     * 格式化任务日期（今天/昨天 + 时间格式）
     * @param date 任务日期(unix timestamp)
     * @returns 格式化后的任务日期
     */
    format(date: number): string;

    /**
     * @description
     * 通用日期格式化方法
     * @param date 日期（字符串或 Unix timestamp）
     * @param pattern 格式化模式（如 'YYYY-MM-DD', 'YYYYMMDD'）
     * @returns 格式化后的日期字符串
     */
    formatWithPattern(date: string | number, pattern: string): string;

    /**
     * @description
     * 判断 date1 是否晚于 date2
     * @param date1 日期1（字符串或 Unix timestamp）
     * @param date2 日期2（字符串或 Unix timestamp）
     * @returns date1 > date2 返回 true
     */
    isAfter(date1: string | number, date2: string | number): boolean;

    /**
     * @description
     * 判断 date1 是否早于 date2
     * @param date1 日期1（字符串或 Unix timestamp）
     * @param date2 日期2（字符串或 Unix timestamp）
     * @returns date1 < date2 返回 true
     */
    isBefore(date1: string | number, date2: string | number): boolean;

    /**
     * @description
     * 比较两个日期
     * @param date1 日期1（字符串或 Unix timestamp）
     * @param date2 日期2（字符串或 Unix timestamp）
     * @returns date1 > date2 返回 1, date1 < date2 返回 -1, 相等返回 0
     */
    compare(date1: string | number, date2: string | number): number;

    /**
     * @description
     * 获取当前时间戳（便于测试 mock）
     * @returns 当前 Unix timestamp (毫秒)
     */
    now(): number;
}
